/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable react/prop-types */
import {useContext, useEffect, useState} from 'react'

import Context from '@s-ui/react-context'
import {FilterBasicLegacyMultiSelection, filterBasicLegacyMultiSelectionDesigns} from '@adv-mt/mt-filter-basic-legacy'

const ModelList = ({make, onChange, value}) => {
  const [selectedModels, setSelectedModels] = useState(value)

  const {domain} = useContext(Context)

  const config = domain.get('config')
  const {DEFAULT_MODEL, DEFAULT_VEHICLE, FILTER_NAMES} = config.get('search')

  useEffect(() => {
    setSelectedModels(make.hasAllSelectionsLabel ? value : value.filter(id => id !== String(DEFAULT_MODEL.id)))
  }, [make, value])

  const defaultAreAllOptionsChecked = selectedModels.includes(String(DEFAULT_MODEL.id))

  const getMakeVehiclesForEmptyMakeModels = () => {
    const [currentValue] = value
    return currentValue === String(DEFAULT_MODEL.id)
      ? []
      : [{...DEFAULT_VEHICLE, [FILTER_NAMES.MAKE]: make.id, make: make.label}]
  }

  const getMakeVehiclesForMakeModels = ({modelsIds}) => {
    if (!modelsIds.length) return []
    if (make.hasAllSelectionsLabel) {
      const areAllModelsSelected = make.models.every(({id}) => modelsIds.includes(String(id)))
      if (areAllModelsSelected) return [{...DEFAULT_VEHICLE, [FILTER_NAMES.MAKE]: make.id, make: make.label}]
    }
    return modelsIds.map(modelId => ({
      ...DEFAULT_VEHICLE,
      [FILTER_NAMES.MAKE]: make.id,
      make: make.label,
      [FILTER_NAMES.MODEL]: {id: modelId, name: make.models.find(({id}) => String(id) === String(modelId))?.label}
    }))
  }

  const getMakeVehicles = ({modelsIds}) => {
    const isMakeWithoutModels = !make.models.length
    return isMakeWithoutModels ? getMakeVehiclesForEmptyMakeModels() : getMakeVehiclesForMakeModels({modelsIds})
  }

  const handleSelectModels = modelsIds => {
    const makeVehicles = getMakeVehicles({modelsIds})
    onChange({makeId: make.id, vehicles: makeVehicles})
  }

  return (
    <FilterBasicLegacyMultiSelection
      allSelectionsLabel={make.hasAllSelectionsLabel && 'Todos los modelos'}
      defaultAreAllOptionsChecked={defaultAreAllOptionsChecked}
      design={filterBasicLegacyMultiSelectionDesigns.HIGHLIGHTED}
      onChange={handleSelectModels}
      options={make.models}
      values={selectedModels}
    />
  )
}

export default ModelList
